export default __webpack_public_path__ + "locales/az/RoomLogoCover.json?hash=b368d1a81a443b74fece5afb10d80dba";